/**
 *
 * Asynchronously loads the component for Catalog
 *
 */
import React from 'react';

import { LoadingContainer } from 'app/components/LoadingContainer';
import { lazyLoad } from 'utils/loadable';

export const Catalog = lazyLoad(
  () => import('./index'),
  module => module.Catalog,
  { fallback: <LoadingContainer loading /> },
);
